import { Component, Input } from "@angular/core";
import { CommonModule } from "@angular/common";
import { HlmSpinnerComponent } from "@spartan-ng/ui-spinner-helm";

@Component({
  selector: "thalea-page-loader",
  imports: [CommonModule, HlmSpinnerComponent],
  templateUrl: "./page-loader.component.html",
  styleUrl: "./page-loader.component.css",
})
export class PageLoaderComponent {
  @Input() message?: string;
  @Input() subMessage?: string;
}
